/**
 * @description Se cargan los elementos del assets en un obheto
 * @example
 * import assets from 'src/assets';
 *
 * assets.images.logo
 * assets.images.techintIcon
 */
const assets = {
    images: {
        techintIcon: require("./images/favicon.ico"),
        logo: require("./images/app-logo.png"),
    }
};

export default assets;
